import { useEffect } from 'react';

const useHeaderScroll = () => {
  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector('header');
      const topBar = document.querySelector('header .top_bar');

      if (!header || !topBar) {
        return;
      }

      const isScrolled =
        document.body.scrollTop > 50 || document.documentElement.scrollTop > 50;

      header.classList.toggle('dark_mode', isScrolled);
      topBar.classList.toggle('top-up', isScrolled);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
};

export default useHeaderScroll;
